import { SwitchableModeThemeProvider } from '@redis-ui/styles';
import { ThemeSwitchProviderProps } from './ThemesProvider.types';
import { theme as themeLight } from '../../themeLight/theme';
import { theme as themeDark } from '../../themeDark/theme';
import { ThemeChangeHandler } from './ThemeChangeHandler';

const THEME_STORAGE_KEY = 'theme';

const ThemesProvider = ({ children }: ThemeSwitchProviderProps) => {
  return (
    <SwitchableModeThemeProvider
      lightTheme={themeLight}
      darkTheme={themeDark}
      storageKey={THEME_STORAGE_KEY}
      defaultThemeMode="system"
      allowSystemThemeMode
    >
      <ThemeChangeHandler />
      {children}
    </SwitchableModeThemeProvider>
  );
};

export default ThemesProvider;
